import { Variants } from 'framer-motion';

export const closeButtonVariants: Variants = {
	animate: {
		left: '86%',
		top: '2%',
	},
};
export const fadeVariants: Variants = {
	open: {
		left: '50%',
		opacity: 1,
		top: '50%',
		transition: {
			delay: 0.2,
		},
		x: '-50%',
		y: '-50%',
		zIndex: 10,
	},
	close: {
		left: '50%',
		opacity: 0,
		top: '50%',
		x: '-50%',
		y: '-50%',
		zIndex: 10,
	},
};
export const overlayVariants: Variants = {
	animate: {
		background: 'rgba(0, 0, 0, 0.7)',
		opacity: 1,
	},
	exit: {
		opacity: 0,
		transition: {
			delay: 0.2,
		},
	},
};
